var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "73CF32E7-D371-4702-BB1D-E75BC9D7DD0F@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Icons/System/Arrows/Right"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    transform: "translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000) ",
    points: "-1.77635684e-15 0 24 0 24 24 -1.77635684e-15 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.111,10.939 L7.868,15.182 C7.47753468,15.5724653 6.84446532,15.5724653 6.454,15.182 C6.06353468,14.7915347 6.06353468,14.1584653 6.454,13.768 L11.4038932,8.81810678 C11.7944175,8.42758249 12.4275825,8.42758249 12.8181068,8.81810678 L17.768,13.768 C18.1584653,14.1584653 18.1584653,14.7915347 17.768,15.182 C17.3775347,15.5724653 16.7444653,15.5724653 16.354,15.182 L12.111,10.939 L12.111,10.939 Z",
    id: "Path",
    fill: "currentColor",
    transform: "translate(12.111000, 12.000000) rotate(-270.000000) translate(-12.111000, -12.000000) "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon_arrow_right.3a350f42e91a07b5d8c4f75b3e59fdc1.svg";
export { ForwardRef as ReactComponent };